export default "__VITE_ASSET__orp5uraR__"